import { useEffect, useState } from 'react';
import { trackFeature } from '@/utils/adobeLaunch';
import { isABTestActive, isCYOMode, isSmartomat } from '@/utils/params';
import { IconComponent } from '@/components/common/icons/BaseIcon';
import { FullscreenOff } from '@/components/common/icons/FullscreenOff';
import { FullscreenOn } from '@/components/common/icons/FullscreenOn';

export const useFullScreen = (
  isInitialFullScreen = false
): [() => void, IconComponent] | [undefined] => {
  const [fullscreenActive, setFullscreenActive] = useState(false);

  useEffect(() => {
    const closeFC = (event: MessageEvent<string>) => {
      if (event.data === 'closeFullscreen') {
        trackFeature('fullscreen-close-for-basket');
        setFullscreenActive(false);
      }
    };
    window.addEventListener('message', closeFC);
    return () => window.removeEventListener('message', closeFC);
  }, []);

  if (isCYOMode()) {
    return [
      () => {
        const isABTest = isABTestActive('2024-19_B_Expanded') && isSmartomat();
        const closeMessage = isABTest ? 'closeFullscreen--animation' : 'closeFullscreen';
        const openMessage = isABTest ? 'openFullscreen--animation' : 'openFullscreen';
        if (!isInitialFullScreen) {
          trackFeature(fullscreenActive ? 'fullscreen-close' : 'fullscreen-open');
        }
        window.parent.postMessage(fullscreenActive ? closeMessage : openMessage, '*');
        setFullscreenActive(!fullscreenActive);
      },
      fullscreenActive ? FullscreenOff : FullscreenOn,
    ];
  }

  return [undefined];
};
